import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { StaggerGroup, fadeUp } from "@/components/motion/Reveal";
import Icon from "@/components/Icon";
import { CORE_AREAS } from "@/data/site";

export default function CoreAreas() {
  return (
    <section className="section-pad bg-white" data-testid="core-areas-section">
      <div className="container-sky">
        <SectionHeading
          align="center"
          eyebrow="Two Core Areas of Expertise"
          title="Complementary Strengths, One Safety Partner"
          description="SKY brings together Workplace Safety & Health and Fire Safety & Emergency Preparedness — the two disciplines organisations need to stay safe, compliant and ready."
          className="mb-14"
        />

        <StaggerGroup className="grid gap-7 lg:grid-cols-2">
          {CORE_AREAS.map((area) => (
            <motion.div
              key={area.id}
              variants={fadeUp()}
              data-testid={`expertise-card-${area.id}`}
              className="group relative overflow-hidden rounded-[1.8rem] border border-slate-100 bg-surface"
            >
              <div className="relative h-60 overflow-hidden sm:h-72">
                <img
                  src={area.image}
                  alt={area.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy-deep/40 to-transparent" />
                <div className="absolute bottom-5 left-6 flex items-center gap-3">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/15 text-white backdrop-blur">
                    <Icon name={area.icon} className="h-6 w-6" />
                  </span>
                  <h3 className="max-w-[14rem] font-heading text-xl font-bold text-white sm:text-2xl">
                    {area.title}
                  </h3>
                </div>
              </div>

              <div className="p-7 sm:p-8">
                <ul className="grid grid-cols-1 gap-x-5 gap-y-3 sm:grid-cols-2">
                  {area.items.map((item) => (
                    <li key={item} className="flex items-center gap-2.5">
                      <Check className="h-4 w-4 shrink-0 text-brand" strokeWidth={3} />
                      <span className="text-sm font-medium text-navy">{item}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to={area.link}
                  className="mt-7 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-ink transition-colors hover:text-navy"
                >
                  Explore this area <ArrowUpRight className="h-4 w-4" />
                </Link>
              </div>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
